import axios from "axios";
import jwt_decode from 'jwt-decode';
import { receiveRefreshedSession, logoutUser } from '../redux/actions/session_actions';

let store;

export const injectStore = (_store) => {
  store = _store;
};

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwtToken');
    if (token && config.headers) {
      config.headers['Authorization'] = 'bearer ' + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    // A 401 from the refresh call itself means the refresh token is no good.
    // Retrying it would call refresh again in an endless loop, so let it fall
    // through to the catch below, which signs out.
    const isRefreshRequest = originalRequest?.url?.includes('/api/users/refresh');

    let refreshToken = localStorage.getItem("refreshToken");
    if (
      refreshToken &&
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !isRefreshRequest
    ) {
      originalRequest._retry = true;
      console.log("[Axios Interceptor] Caught 401. Attempting token refresh...");
      
      try {
        const res = await axios.post(`/api/users/refresh`, { refreshToken: refreshToken });
        const newAccessToken = res.data.accessToken;
        console.log("[Axios Interceptor] Refresh successful. Updating token, state, and retrying original request.");

        localStorage.setItem("jwtToken", newAccessToken);
        setAuthToken(newAccessToken);
        
        originalRequest.headers["Authorization"] = "bearer " + newAccessToken;

        if (store) {
          try {
            const decodedUser = jwt_decode(newAccessToken);
            let currentRefreshTokenExp = null;
            try {
                const decodedRefresh = jwt_decode(refreshToken);
                currentRefreshTokenExp = decodedRefresh.exp;
            } catch (decodeError) {
                console.warn("[Axios Interceptor] Could not decode existing refresh token during state update:", decodeError);
                store.dispatch(logoutUser());
                return Promise.reject(new Error("Invalid refresh token."));
            }
            store.dispatch(receiveRefreshedSession(newAccessToken, currentRefreshTokenExp));
          } catch (decodeError) {
              console.error("[Axios Interceptor] Failed to decode new access token or dispatch update:", decodeError);
              store.dispatch(logoutUser());
              return Promise.reject(new Error("Failed to process refreshed token."));
          }
        } else {
            console.error("[Axios Interceptor] Store not injected. Cannot dispatch state update. Logging out.");
            localStorage.removeItem('jwtToken');
            localStorage.removeItem('refreshToken');
            setAuthToken(false);
            return Promise.reject(new Error("Store not available for session update."));
        }

        console.log("[Axios Interceptor] Retrying original request:", originalRequest.url);
        return axios(originalRequest);

      } catch (refreshError) {
        console.error("[Axios Interceptor] Refresh token API call failed:", refreshError?.response?.data || refreshError.message);
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('refreshToken');
        setAuthToken(false);
        if (store) {
           store.dispatch(logoutUser());
        }
        return Promise.reject(refreshError);
      }
    } 
    return Promise.reject(error);
  }
);

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = "bearer " + token;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const signupUser = (userData) => {
  return axios.post(`/api/users/register`, userData);
};

export const loginUser = (userData) => {
  var req = axios.post(`/api/users/login`, userData);
  return req;
};

export const userRefreshToken = (refreshToken) => {
  return axios.post(`/api/users/refresh`, { refreshToken: refreshToken });
};
